// extracted by mini-css-extract-plugin
module.exports = {"gradient":"Avatar_gradient__3xDdY","default":"Avatar_default__1viPq","large":"Avatar_large__szRQb","medium":"Avatar_medium__1ZStr"};